export const Industries = axios => ({
  /**
   * Get industries list
   *
   * @returns Promise
   */
  list() {
    return axios.get('/v1/industries')
  }
})
